export enum Routes {
	HOME = 'HOME',
	GROUPS = 'GROUPS',
	GROUP = 'GROUP',
	GROUP_MAIN = 'GROUP_MAIN',
	GROUP_CONTENT = 'GROUP_CONTENT',
	GROUP_EVENTS = 'GROUP_EVENTS',
	GROUP_EVENT = 'GROUP_EVENT',
	GROUP_CUSTOM = 'GROUP_CUSTOM',
	GROUP_MEMBERS = 'GROUP_MEMBERS',
	GROUP_DISCUSSION = 'GROUP_DISCUSSION',
	GROUP_LEARNING = 'GROUP_LEARNING',
	GROUP_LEARNING_PROGRAMS_LIST = 'GROUP_LEARNING_PROGRAMS_LIST',
	GROUP_LEARNING_PROGRAM = 'GROUP_LEARNING_PROGRAM',
	GROUP_LEARNING_MODULE = 'GROUP_LEARNING_MODULE',
	GROUP_ADMIN = 'GROUP_ADMIN',
	GROUP_ADMIN_DATA = 'GROUP_ADMIN_DATA',
	GROUP_ADMIN_HIGHLIGHTS = 'GROUP_ADMIN_HIGHLIGHTS',
	GROUP_ADMIN_LEARNING_PROGRAMS = 'GROUP_ADMIN_LEARNING_PROGRAMS',
	GROUP_ADMIN_LEARNING_PROGRAMS_ALL_PROGRAMS = 'GROUP_ADMIN_LEARNING_PROGRAMS_ALL_PROGRAMS',
	GROUP_ADMIN_LEARNING_PROGRAMS_LIST = 'GROUP_ADMIN_LEARNING_PROGRAMS_LIST',
	GROUP_ADMIN_MANAGE_LEARNING_PROGRAM = 'GROUP_ADMIN_MANAGE_LEARNING_PROGRAM',
	GROUP_ADMIN_LEARNING_PROGRAMS_MANAGE_SURVEYS = 'GROUP_ADMIN_LEARNING_PROGRAMS_MANAGE_SURVEYS',
	GROUP_ADMIN_SURVEY_MANAGEMENT_LIST = 'GROUP_ADMIN_SURVEY_MANAGEMENT_LIST',
	GROUP_ADMIN_SURVEY_EDIT = 'GROUP_ADMIN_SURVEY_EDIT',
	GROUP_ADMIN_SURVEY_CREATE = 'GROUP_ADMIN_SURVEY_CREATE',
	GROUP_ADMIN_SURVEY_RESPONSES = 'GROUP_ADMIN_SURVEY_RESPONSES',
	GROUP_ADMIN_MEMBER_MANAGEMENT = 'GROUP_ADMIN_MEMBER_MANAGEMENT',
	GROUP_ADMIN_ADD_MEMBERS = 'GROUP_ADMIN_ADD_MEMBERS',
	GROUP_ADMIN_INVITE_CAMPAIGN = 'GROUP_ADMIN_INVITE_CAMPAIGN',
	GROUP_ADMIN_SECURITY_AND_ACCESS_CONTROL = 'GROUP_ADMIN_SECURITY_AND_ACCESS_CONTROL',
	GROUP_ADMIN_DESIGN_AND_CONFIGURATION = 'GROUP_ADMIN_DESIGN_AND_CONFIGURATION',
	GROUP_ADMIN_DESIGN_AND_CONFIGURATION_CATEGORIES = 'GROUP_ADMIN_DESIGN_AND_CONFIGURATION_CATEGORIES',
	GROUP_ADMIN_DESIGN_AND_CONFIGURATION_CUSTOM_PAGE = 'GROUP_ADMIN_DESIGN_AND_CONFIGURATION_CUSTOM_PAGE',
	GROUP_ADMIN_NOTIFICATIONS_AND_DIGESTS = 'GROUP_ADMIN_NOTIFICATIONS_AND_DIGESTS',
	GROUP_ADMIN_NOTIFICATION_SETTINGS = 'GROUP_ADMIN_NOTIFICATION_SETTINGS',
	GROUP_ADMIN_DIGESTS = 'GROUP_ADMIN_DIGESTS',
	GROUP_ADMIN_EVENT_CREATE = 'GROUP_ADMIN_EVENT_CREATE',
	GROUP_EVENT_LOGIN = 'GROUP_EVENT_LOGIN',
	GROUP_LOGIN = 'GROUP_LOGIN',
	EVENTS = 'EVENTS',
	EVENT = 'EVENT',
	EVENT_LOGIN = 'EVENT_LOGIN',
	EVENT_ADMIN = 'EVENT_ADMIN',
	EVENT_ADMIN_DETAILS = 'EVENT_ADMIN_DETAILS',
	EVENT_ADMIN_MANAGEMENT = 'EVENT_ADMIN_MANAGEMENT',
	// EVENT_ADMIN_INVITATIONS = 'EVENT_ADMIN_INVITATIONS',
	LOGIN = 'LOGIN',
	SIGNUP = 'SIGNUP',
	ACTIVATION_SUCCESS = 'ACTIVATION_SUCCESS',
	ACTIVATION_ERROR = 'ACTIVATION_ERROR',
	ACTIVATION_REQUIRED = 'ACTIVATION_REQUIRED',
	ACTIVATION_ALREADY_ACTIVATED = 'ACTIVATION_ALREADY_ACTIVATED',
	INVITATION_DECLINE = 'INVITATION_DECLINE',
	CURRENT_USER_PROFILE = 'CURRENT_USER_PROFILE',
	USER_PROFILE = 'USER_PROFILE',
	USER_SETTINGS = 'USER_SETTINGS',
	USER_LEARNING_PROGRAMS = 'USER_LEARNING_PROGRAMS',
	CSR = 'CSR',
	CHANNEL_REPORTS = 'CHANNEL_REPORTS', // Event banner data
	CHANNEL_REPORTS_FOR_EVENT = 'CHANNEL_REPORTS_FOR_EVENT', // Event banner data
	COMMUNITY_MANAGEMENT = 'COMMUNITY_MANAGGEMENT', // All communities
	MANAGE_COMMUNITY = 'MANAGE_COMMUNITY', // Manage a specific community
	MANAGE_COMMUNITY_EDIT_COMMUNITY = 'MANAGE_COMMUNITY_EDIT_COMMUNITY',
	MANAGE_COMMUNITY_CONTENTS = 'MANAGE_COMMUNITY_CONTENTS',
	MANAGE_COMMUNITY_SETTINGS = 'MANAGE_COMMUNITY_SETTINGS',
}
